import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TslToastrService } from '@tesla/ng-tds';
import { PostEvent } from 'app/profile/store/app.actions';
import { SelectEventData } from 'app/profile/store/app.selector';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { I18nService } from 'app/shared/services/i18n.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cancel-request-dialog',
  templateUrl: './cancel-request-dialog.component.html',
  styleUrls: ['./cancel-request-dialog.component.scss']
})
export class CancelRequestDialogComponent implements OnInit, OnDestroy {
  supplierCode: string;
  requestId: string;
  requestType: string;
  form: FormGroup;
  commentControl: FormControl;
  cancelSub: Subscription;

  constructor(
    public dialogRef: MatDialogRef<CancelRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toaster: TslToastrService,
    private translate: I18nService,
    private formBuilder: FormBuilder,
    private store: Store<SupplierState>,
  ) { }

  ngOnInit(): void {
    if(this.data) {
      this.supplierCode = this.data?.supplierCode;
      this.requestId = this.data?.requestId;
      this.requestType = this.data?.requestType;
    }
    this.initForm()
  }

  initForm() {
    this.commentControl = new FormControl('', [Validators.required]);
    let formList = {};
    formList["Comment"] = this.commentControl;
    this.form = this.formBuilder.group(formList);
  }

  onClose() {
    this.dialogRef.close();
  }

  onSubmit() {
    if(!this.form?.valid) {
      this.form.markAllAsTouched();
      return;
    }
    let res = this.form.value;
    let actionName;
    switch(this.requestType) {
      case "NameOrTINChange": {
        actionName = "Name Or TIN Change Cancelled";
        break;
      }
    }
    let body = {
      ReferenceSystem: "Supplier",
      Name: actionName,
      Properties: res,
      ReferenceIdentifier: this.supplierCode
    };
    this.store.dispatch(new PostEvent(body));
    this.cancelSub = this.store.select(SelectEventData).subscribe(res => {
      if (res) {
        this.dialogRef.close(true);
      }
    });
  }

  ngOnDestroy(): void {
    this.cancelSub?.unsubscribe();
  }
}
